import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PageChangedEvent} from 'ngx-bootstrap/pagination';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
    selector: 'app-WebinarsPresentations',
    templateUrl: './WebinarsPresentations.component.html',
    styleUrls: ['./WebinarsPresentations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebinarsPresentationsComponent implements OnInit {
  status = false;
  showBoundaryLinks = true;
  showDirectionLinks = true;

  returnVideoPage: VideoGridElement[];
  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/5rUgwPIXcsw ',
      title: '2026 Business Personal Property Statement Webinar',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/1GlIAxcW2gI',
      title: 'Disaster Relief - Change of Mailing Address',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/61U7eTv6mRM',
      title: 'Misfortune and Calamity: Notices of Assessed Value Change Explained',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/8pYFZRpwrkQ',
      title: 'LA County Assessor Jeff Prang\'s Disaster Relief Webinar',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/EJswhIach4M',
      title: 'Assessor Jeff Prang\'s Business Personal Property Statement Webinar (03/06/25)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/_U9iIUwfY04',
      title: 'Assessor Jeff Prang\'s Business Personal Property Statement Webinar (03/04/25)',
      powerpoint: null
    },
    // {
    //   url: 'https://www.youtube.com/embed/mFKosAFIjSQ',
    //   title: 'Assessor\'s Boat & Vessel Owners Town Hall 2024',
    //   powerpoint: null
    // },
    {
      url: 'https://www.youtube.com/embed/1nLaIoOIKH0',
      title: 'Business Personal Property Presentation 2024',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/gzRdcJwpVDk',
      title: 'Preparing the Business Personal Property Statement',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1680545747/Webinars%20and%20Presentations/Assessor_571-L_Seminar_Overview_2023_-_Final.pdf'
    },
    {
      url: 'https://www.youtube.com/embed/x5XyO_QAo6o',
      title: 'LA County Assessor Jeff Prang\'s Oath of Office',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/x6mTmxhRM-s',
      title: 'Nicole White-Gamble Speaking at the Homeownership Legacy Workshop with Macedonia Baptist Church',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/epqN7dEYDvQ?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 1: ADUs with Jennifer Budzak',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/fb4g6JcGWuc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'PRESENTATION 2: PROPOSITION 19 & DEATH OF A PROPERTY OWNER',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/RWvuJaZkbrc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'PRESENTATION 3: HOMEOWNERS\' EXEMPTION WITH FRANK DIAZ, JR.',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/C7gmy7qWfMg?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'PRESENTATION 4: DISABLED VETERANS\' EXEMPTION WITH DENNY ESTRADA',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/h26VwrwuvvQ?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: '2022 HOMEOWNERS\' RESOURCE FAIR',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/p0RDDQ0FoyQ',
      title: 'FORM 571-L Q & A RECORDED ZOOM',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/th4ngfa9C3c',
      title: 'How to Prepare a Business Personal Property Statement, Form 571-L (QUICK POWERPOINT)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/6r2KZriF5SE',
      title: 'How to Prepare a Business Personal Property Statement, Form 571-L (ENGLISH)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/nTyJ79thsw8',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Spanish)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/McZ0p2rf04w',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Chinese)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/-x62Y4i0GpQ',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Persian)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/5cd0MGUKl9A',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (armenian)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/06uofHAZ8qU',
      title: 'ASSESSOR’S ADU RESOURCE SEMINAR',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/-EgVNcykiXY',
      title: 'PROP. 19 – WILL I BE ELIGIBLE FOR A BASE YEAR VALUE TRANSFER?',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/PQrvFBOjjWc',
      title: 'PROP. 19 – TAX BASE FROM AN ORIGINAL PROPERTY TO REPLACEMENT PROPERTY ANYWHERE IN THE STATE.',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/L9hIGHhMXYA',
      title: 'PROP. 19 – HOMEOWNERS’ EXEMPTION TO QUALIFY FOR THE PARENT-CHILD AND GRANDPARENT-GRANDCHILD EXCLUSIONS?',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/5aJ7iOz_zLs',
      title: 'Prop. 19 Town Hall (12/08/21)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/OXc8TSyZhaA',
      title: 'What is Prop. 19? (1/22/21)',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1627751261/Webinars%20and%20Presentations/LA_County_Assessor_Prop._19_Webinar_1_22_21.pdf'
    },
    {
      url: 'https://www.youtube.com/embed/ZaNnuXFFLXU',
      title: 'Ask the Assessor: How to Save Money on your Property Tax Bill',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1627750896/Webinars%20and%20Presentations/How-to-Save-Money-on-your-Property-Tax-Bill_LACounty-Assessor_2021.pdf'
    },
    {
      url: 'https://www.youtube.com/embed/bbJsD7jaSpg',
      title: 'Misfortune and Calamity: Notices of Assessed Value Change Explained',
      powerpoint: null
    },
  ];

  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.returnVideoPage = this.videos.slice(startItem, endItem);
 }

  ngOnInit(): void {
    this.returnVideoPage = this.videos.slice(0, 6);
  }

}
